// src/components/LayoutWithHeader.tsx
import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import GlobalHeader from "../components/GlobalHeader";
import { useAuth } from "../contexts/AuthContext";
import { usePartnerInfo } from "../hooks/usePartnerInfo";

const LayoutWithHeader: React.FC = () => {
  const { subscriptionPlan, hasActiveSubscription } = useAuth();
  const location = useLocation();
  const { isPartner, logo, displayName, logoHeaderClassName } =
    usePartnerInfo();

  // Check if we're in the interview process
  const isInInterview = location.pathname.includes("/mock-case");

  return (
    <>
      <GlobalHeader
        subscriptionLevel={
          hasActiveSubscription ? subscriptionPlan?.name || "Free" : "Free"
        }
        hideUserIcon={isInInterview}
        companyLogo={isPartner && logo ? logo : undefined}
        companyName={isPartner && displayName ? displayName : undefined}
        companyLogoHeaderClassName={
          isPartner && logoHeaderClassName ? logoHeaderClassName : ""
        }
      />
      <Outlet />
    </>
  );
};

export default LayoutWithHeader;
